import React, { useState } from "react";
import { IconBrandTwitch, IconQuestionMark } from "@tabler/icons";
import { HoverCard, Button, Text, TextInput, Divider, Loader } from "@mantine/core";
import axios, { AxiosError } from "axios";
import { BrandTwitch, Broadcast, DeviceTv } from "tabler-icons-react";

export default function UploadVOD({ user, details, setUploaded, uploaded, setOpened2, opened2 }) {
  // console.log("CAMPAIGN ID: " + details.streamers.id);

  const [vodId, setVodId] = useState("");
  console.log("VOD ID" + vodId);
  const [status, setStatus] = useState(0);

  async function sleepTrigger(){
    await sleep(750);
    opened2 = false;
    setOpened2(opened2);
  }

  const sleep = ms => new Promise(r => setTimeout(r, ms))

  async function sleepTriggerFailed(){
    await sleepFailed(1500);
    setStatus(0)
  }

  const sleepFailed = ms => new Promise(r => setTimeout(r, ms))

  const submitVOD = () => {
    setStatus(99)
    axios
      .post(
        "https://0oh354a4kc.execute-api.eu-north-1.amazonaws.com/submit-vod/",
        {
          vod_id: vodId,
          campaign_id: details.campaign_id,
          streamer_id: details.streamers.id,
        },
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        console.log(res.body);
        setStatus(res.status);
        uploaded = true
        setUploaded(true);
        setVodId("");
        if (res.status == 200) {
          sleepTrigger();
        }
      }).catch((error) => {
        setStatus(400)
        sleepTriggerFailed();
      });
  };

  return (
    <div style={{ justifyContent: "center", alignItems: "center" }}>
      <Text size="md" weight="bold" pl={10} mt={5} mb={5}>
        Submit VOD URL
      </Text>
      <div style={{ display: "flex", paddingLeft: 10, marginBottom: 10 }}>
        <Text>Submit the link from your sponsored stream</Text>
        <HoverCard width={420} shadow="md">
          <HoverCard.Target>
            <div>
              <IconQuestionMark
                size={12}
                style={{
                  display: "block",
                  opacity: 0.5,
                  border: "1px solid #161616",
                  borderRadius: 10,
                  cursor: "pointer",
                }}
              />
            </div>
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <Text size="sm" weight="bold">
              Where do I find this link?
            </Text>
            <div style={{ display: "flex" }}>
              <Text size="sm">
                Go to your profile on Twitch, select the sponsored stream and
                copy the url, e.g., https://www.twitch.tv/videos/123530539
              </Text>
            </div>
            <Text size="sm" weight="bold" mt={5}>
              Supported Link Formats
            </Text>
            <Text size="sm">
              Full url - https://www.twitch.tv/videos/123530539
            </Text>
            <Text size="sm">Long link - www.twitch.tv/videos/123530539</Text>
            <Text size="sm">Short link - twitch.tv/videos/123530539</Text>
            <Text size="sm">VOD url - 123530539</Text>
          </HoverCard.Dropdown>
        </HoverCard>
      </div>
      <div style={{ display: "flex", paddingLeft: 10, marginBottom: 20 }}>
        <TextInput
          icon={<IconBrandTwitch size={18} />}
          style={{ width: 300 }}
          placeholder="www.twitch.tv/videos/213831230"
          onChange={(event) => {
            setVodId(event.currentTarget.value);
          }}
        />
        <Button
          color={status == 200 ? "green" : status == 400 ? "red" : status == 99 ? "blue" : ""}
          size="sm"
          disabled={status == 99 ? true : false}
          ml={5}
          onClick={() => submitVOD()}
        >
          {status == 200 ? (
            <div>Successfully Submitted</div>
          ) : (
            status == 99 ? (
            <>
            <Text size="xs">Loading</Text>
            <Loader color="white" size="sm"/>
            {/* <div>Submit VOD</div> */}
            </>
            ) : status == 400 ? <Text size="xs">Try Again...</Text>:<Text size="xs">Submit VOD</Text>
          )}
        </Button>
      </div>
      <div style={{ paddingLeft: 10, marginBottom: 10 }}>
        <Text size="md" weight="bold" mt={5} mb={5}>
          Uploaded VODs
        </Text>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            width: "100%",
            padding: 5,
          }}
        >
          <Text size="sm" style={{ width: "10%" }}>
            Id
          </Text>
          <Text size="sm" style={{ width: "45%" }}>
            Title
          </Text>
          <Text size="sm" style={{ width: "30%" }}>
            Stream Date
          </Text>
          <Text size="sm" style={{ width: "15%" }}>
            Link
          </Text>
        </div>
        <Divider mb={5}/>
        {details?.streamers?.submitted_vods?.map((vod, ind) => {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  width: "100%"
                }}
              >
                <Text size="sm" ml={5} style={{ width: "10%" }}>
                  {ind+1}
                </Text>
                <Text truncate size="sm" style={{ width: "45%" }}>
                 {vod?.title[ind]}
                </Text>
                <Text size="sm" style={{ width: "30%" }}>
                  {vod?.started_at[0]?.split("T")[0]}
                </Text>
                <div style={{ width: "15%" }}>
                  <a href={vod?.vod_id} target="_blank">
                    <BrandTwitch
                      color="#6441a5"
                      style={{ textDecoration: "none" }}
                    />
                  </a>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
}
